import { AnyObj } from '@weapp/ui';
import { classnames, eventEmitter, getLabel } from '@weapp/utils';
import { runInAction } from 'mobx';
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { BaseProps } from '../../../components/page-view/types';
import { pageViewClsPrefix } from '../../../constants';
import { isPassportEbpage } from '../../../utils';
import ebdcoms from '../../../utils/ebdcoms';
import { OtherProps } from '../../types';
import { getDialogTopFormLeft } from '../../utils';
import SingCom from './SingleCom';

export const suffix = 'dlg/';

/**
 * 暂时支持标准弹框的系统页面
 * 上传文件
 * 新建客户
 * 新建联系人
 * 客户详情
 */

const { SystemPageType, PageType } = ebdcoms.get();
const { Combinate } = PageType;
const {
  UploadFile,
  NewCustomer,
  NewContact,
  CustomerDetail,
  ContactDetail,
  ContractDetail,
  ContractRiskDetails,
  ContractCollectionDetails,
  ContractPaymentDetails,
  ContractInvoicingDetails,
  OrderDetail,
  PriceDetail,
  OpportunityDetail,
  ClueDetail,
  NewOrder,
  NewPrice,
  NewOpportunity,
  NewClue,
  NewProduct,
  ProductDetail,
  NewContract,
  NewContactRecord,
  NewSchedule,
  ScheduleDetail,
  NewMeeting,
  MeetingDetail,
  MeetingRoomInfo,
  NewCooperation,
  CooperationDetail,
  TADocument,
  TAApproval,
  PerformanceDetail,
  CrmNewContactRemind,
  PerformanceSchemeDetail,
  PerformanceAgentEdit,
  PerformanceSchemeEdit,
  PlanDetail,
  DataDetail,
  SubmitApplication,
  NewProject,
  ProjectDetail,
  ProjectBoard,
  ProjectStatusFlow,
  NewTask,
  TaskDetail,
  NewMarketActivity,
  MarketActivityDetail,
  NewCompetitor,
  WeComCustomerDetails,
  IncreaseTrafficRecordDetails,
  NewCopywriting,
  Copywriting,
  PreviewCopywriting,
  CompetitorDetail,
  ApprovalDetail,
  ApprovalNoDisturb,
  ApprovalBatchOperation,
  NewDocument,
  DocumentDetail,
  NewBusinessFormData,
  SendEmail,
  EmailDetail,
  EmailHome,
  WriteDaily,
  Scene,
  AddOdocRequest,
  ItemDetail,
  CustomerIdentification,
  ImportCustomer,
  BatchEditCustomer,
  ImportContactReminder,
  ContactIdentification,
  ImportContact,
  ImportContactRecord,
  BatchEditOpportunities,
  BatchEditClues,
  GetSignLink,
  WithdrawSign,
  InvalidSign,
  OdocDetail,
  OdocLibDetail,
  StartSign,
  RejectSign,
  CounterSign,
  SignDetail,
  SignatureDetail,
  WithdrawApply,
  InvoiceDetail,
} = SystemPageType;

const supportedSysPage = [
  { type: UploadFile },
  { type: NewCustomer },
  { type: NewContact },
  { type: CustomerDetail },
  { type: ContactDetail },
  { type: ContractDetail },
  { type: ContractRiskDetails },
  { type: ContractCollectionDetails },
  { type: ContractPaymentDetails },
  { type: ContractInvoicingDetails },
  { type: OrderDetail },
  { type: PriceDetail },
  { type: OpportunityDetail },
  { type: ClueDetail },
  { type: NewOrder },
  { type: NewPrice },
  { type: NewOpportunity },
  { type: NewClue },
  { type: NewProduct },
  { type: ProductDetail },
  { type: NewContract },
  { type: NewContactRecord },
  { type: NewSchedule },
  { type: ScheduleDetail },
  { type: DataDetail },
  { type: SubmitApplication },
  { type: NewProject },
  { type: ProjectDetail },
  { type: ProjectBoard },
  { type: ProjectStatusFlow },
  { type: NewTask },
  { type: TaskDetail },
  { type: NewMarketActivity },
  { type: MarketActivityDetail },
  { type: WeComCustomerDetails },
  { type: IncreaseTrafficRecordDetails },
  { type: NewCopywriting },
  { type: Copywriting },
  { type: PreviewCopywriting },
  { type: NewCompetitor },
  { type: CompetitorDetail },
  { type: ApprovalDetail },
  { type: ApprovalNoDisturb },
  { type: ApprovalBatchOperation },
  { type: NewDocument },
  { type: DocumentDetail },
  { type: NewBusinessFormData },
  { type: SendEmail },
  { type: EmailDetail },
  { type: EmailHome },
  { type: WriteDaily },
  { type: NewMeeting },
  { type: MeetingDetail },
  { type: NewCooperation },
  { type: MeetingRoomInfo },
  { type: CooperationDetail },
  { type: TADocument },
  { type: TAApproval },
  { type: PerformanceDetail },
  { type: PerformanceSchemeDetail },
  { type: CrmNewContactRemind },
  { type: PerformanceAgentEdit },
  { type: PerformanceSchemeEdit },
  { type: PlanDetail },
  { type: AddOdocRequest },
  { type: ItemDetail },
  { type: CustomerIdentification },
  { type: ImportCustomer },
  { type: BatchEditCustomer },
  { type: ImportContactReminder },
  { type: ContactIdentification },
  { type: ImportContact },
  { type: ImportContactRecord },
  { type: BatchEditOpportunities },
  { type: BatchEditClues },
  { type: GetSignLink },
  { type: WithdrawSign },
  { type: InvalidSign },
  { type: OdocDetail },
  { type: OdocLibDetail },
  { type: StartSign },
  { type: RejectSign },
  { type: CounterSign },
  { type: SignDetail },
  { type: SignatureDetail },
  { type: WithdrawApply },
  { type: InvoiceDetail },
];

// eslint-disable-next-line max-len
export const isSupportedSysPage = (type: string) => supportedSysPage.some((page) => page.type === type);

export const isComposePage = (linkPath: string) => /combinationdlg/.test(linkPath);

// const disabledRefreshTypes = [ProjectBoard];

// 客户模块 名片识别 | 导入 | 批量编辑
export const CrmCustomPages = [
  CustomerIdentification,
  ImportCustomer,
  BatchEditCustomer,
  ImportContactReminder,
  ContactIdentification,
  ImportContact,
  ImportContactRecord,
  BatchEditOpportunities,
  BatchEditClues,
];

// 电子签 发起签署 | 获取签署链接 | 撤回文件 | 作废文件 | 退回申请 | 加签 | 签署详情 | 签名详情 | 撤回申请
export const SignPages = [
  StartSign,
  GetSignLink,
  WithdrawSign,
  InvalidSign,
  RejectSign,
  CounterSign,
  SignDetail,
  SignatureDetail,
  WithdrawApply,
];

export enum ModuleType {
  TASK = 'task',
  /* ALL = 'all', */
  DOCUMENT = 'document',
  CUSTOMER = 'customer',
  CONTACT = 'contact',
  PRODUCT = 'production',
  /** 竞争对手 */
  RIVAL = 'competitor',
  PRICE = 'price',
  FUND = 'capital',
  APPROVE = 'approve',
  SCHEDULE = 'schedule',
  MEETING = 'meeting',
  TARGET = 'target',
  ACTIVITY = 'activity',
  /** 合同 */
  CONTRACT = 'contract',
  FORM = 'form',
  THREAD = 'thread',
  ORDER = 'orderform',
  FORMDATAREPORT = 'formdatareport',
  /** 项目 */
  MAINLINE = 'mainline',
  MARKET_ACTIVITY = 'marketactivity',
  SALE = 'salechance',
  CLUE = 'clue',
  CALENDAR = 'calendar',
  WORKFLOW = 'workflow',
  /** 报价 */
  QUOTE = 'quoteInfo',
  MSG = 'msg',
  GROUP = 'group',
  EBUILDERFORM = 'ebuilderform',
}

export const getModuleProjName = (module: string) => {
  if (module === ModuleType.DOCUMENT) {
    return 'doc';
  }
  if (module === ModuleType.MAINLINE) {
    return 'project';
  }
  if (module === ModuleType.FORMDATAREPORT) {
    return 'formreport';
  }
  if (module === ModuleType.MARKET_ACTIVITY) {
    return 'marketactivity';
  }
  if (module === ModuleType.SALE) {
    return 'saleChance';
  }
  return module;
};

// 绘图弹窗共用系统弹窗
// const isScenePage = (dlgType: string) => dlgType?.includes(Scene.toLowerCase());

export const getApp = (id: string, otherParams?: Record<string, any>) => {
  let app = '@weapp/';
  const listType = otherParams?.listType || '1';

  switch (id) {
    case UploadFile:
    case NewDocument:
    case DocumentDetail:
      app += 'doc';
      break;
    case NewCustomer:
    case NewContact:
    case CustomerDetail:
    case ContactDetail:
    case ContractDetail:
    case ContractRiskDetails:
    case ContractCollectionDetails:
    case ContractPaymentDetails:
    case ContractInvoicingDetails:
    case OrderDetail:
    case PriceDetail:
    case OpportunityDetail:
    case ClueDetail:
    case NewOrder:
    case NewPrice:
    case NewClue:
    case NewProduct:
    case ProductDetail:
    case NewOpportunity:
    case NewContract:
    case NewContactRecord:
    case NewMarketActivity:
    case MarketActivityDetail:
    case NewCompetitor:
    case CompetitorDetail:
    case CustomerIdentification:
    case ImportCustomer:
    case BatchEditCustomer:
    case ImportContactReminder:
    case ContactIdentification:
    case ImportContact:
    case ImportContactRecord:
    case BatchEditOpportunities:
    case BatchEditClues:
      app += 'crm';
      break;
    case CrmNewContactRemind:
      app += 'crmcustomer';
      break;
    case NewSchedule:
    case ScheduleDetail:
      app += 'calendar';
      break;
    case NewMeeting:
    case MeetingDetail:
    case MeetingRoomInfo:
      app += 'meeting';
      break;
    case NewCooperation:
    case CooperationDetail:
      app += 'cowork';
      break;
    case PerformanceDetail:
    case PerformanceSchemeDetail:
    case PerformanceAgentEdit:
    case PerformanceSchemeEdit:
      app += 'performance';
      break;
    case PlanDetail:
      app += 'plan';
      break;
    case DataDetail:
    case NewBusinessFormData:
      app += 'formreport';
      break;
    case NewProject:
    case ProjectDetail:
    case ProjectBoard:
    case ProjectStatusFlow:
      app += 'project';
      break;
    case NewTask:
    case TaskDetail:
      app += 'task';
      break;
    case SendEmail:
    case EmailDetail:
      app += 'mail';
      break;
    case WriteDaily:
      app += 'blog';
      break;
    case AddOdocRequest:
      app += 'odoc';
      break;
    case ItemDetail:
      app += 'my';
      break;
    case WeComCustomerDetails:
    case IncreaseTrafficRecordDetails:
    case NewCopywriting:
    case Copywriting:
    case PreviewCopywriting:
      app += 'market';
      break;
    case GetSignLink:
    case InvalidSign:
    case WithdrawSign:
    case StartSign:
    case RejectSign:
    case CounterSign:
    case SignDetail:
    case WithdrawApply:
      app += 'signcenter';
      break;
    case Combinate:
      app += 'appbuilder';
      break;
    case SignatureDetail:
      app += 'profile';
      break;
    case OdocDetail:
      if (listType === '1') {
        app += 'odoc';
      } else {
        app += 'doc';
      }
      break;
    case OdocLibDetail:
      app += 'doc';
      break;
    case InvoiceDetail:
      app += 'inc';
      break;
    default:
      app += 'ebdpage';
      break;
  }
  return app;
};

/**
 * crm 对接地址：
 * https://www.e-cology.com.cn/spa/custom/static/index.html#/main/cs/app/86421e44bf26440ca951b35c3ad1fa4c_baseTable?fileid=14913480&tosharerinfo=b2c2f223-7755-4b9d-8d71-e49c215e0dc8&tosharetype=group&_key=yglwbe
 * https://www.e-cology.com.cn/spa/custom/static/index.html#/main/cs/app/86421e44bf26440ca951b35c3ad1fa4c_baseTable?fileid=14428701&tosharerinfo=11585&tosharetype=person&_key=z8hhc0
 */
export const getCompName = (id: string, placement?: string, otherParams?: Record<string, any>) => {
  let compName = '';
  const isMiddle = placement === 'middle';
  const listType = otherParams?.listType || '1';
  const allComps: any = {
    1: ['OdocFlowFormViewMiddleDialog', 'OdocMsgFlowViewSideDialog'],
    2: ['DocViewDialog', 'DocViewSideDialog'],
  };
  const comps = allComps[listType];

  switch (id) {
    case UploadFile:
      compName = 'UploadFile';
      break;
    case NewDocument:
    case DocumentDetail:
      compName = isPassportEbpage() ? 'DocShare' : 'DocDetailProvider';
      break;
    case NewCustomer:
      compName = 'CrmCreateCustomerDialogProvider';
      break;
    case NewContact:
      compName = 'CrmCreateContactDialogProvider';
      break;
    case CustomerDetail:
      compName = isMiddle ? 'CrmCustomerViewMiddleDialog' : 'CrmCustomerViewDialogProvider';
      break;
    case ContactDetail:
      compName = isMiddle ? 'CrmContactViewMiddleDialog' : 'CrmContactViewDialogProvider';
      break;
    case ContractDetail:
      compName = isMiddle ? 'CrmContractViewMiddleDialog' : 'CrmContractViewDialogProvider';
      break;
    case ContractRiskDetails:
      compName = 'CrmRiskViewDialogProvider';
      break;
    case ContractCollectionDetails:
      compName = 'CrmContractPeriodReceiveDialog';
      break;
    case ContractPaymentDetails:
      compName = 'CrmContractPeriodPayDialog';
      break;
    case ContractInvoicingDetails:
      compName = 'CrmContractPeriodInoviceDialog';
      break;
    case OrderDetail:
      compName = isMiddle ? 'CrmOrderFormViewMiddleDialog' : 'CrmOrderFormViewDialogProvider';
      break;
    case PriceDetail:
      compName = isMiddle ? 'CrmPriceViewMiddleDialog' : 'CrmPriceViewDialogProvider';
      break;
    case OpportunityDetail:
      compName = isMiddle ? 'CrmSaleChanceViewMiddleDialog' : 'CrmSaleChanceViewDialogProvider';
      break;
    case ClueDetail:
      compName = isMiddle ? 'CrmClueViewMiddleDialog' : 'CrmClueViewDialogProvider';
      break;
    case NewOrder:
      compName = 'CrmCreateOrderFormDialogProvider';
      break;
    case NewPrice:
      compName = 'CrmCreatePriceDialogProvider';
      break;
    case NewOpportunity:
      compName = 'CrmCreateSaleChanceDialogProvider';
      break;
    case NewClue:
      compName = 'CrmCreateClueDialogProvider';
      break;
    case NewProduct:
      compName = 'CrmCreateProductionDialogProvider';
      break;
    case ProductDetail:
      compName = isMiddle ? 'CrmProductionViewMiddleDialog' : 'CrmProductionViewDialogProvider';
      break;
    case NewContract:
      compName = 'CrmCreateContractDialogProvider';
      break;
    case NewContactRecord:
      compName = 'CrmCreateRecordDialogProvider';
      break;
    case NewSchedule:
    case ScheduleDetail:
      compName = isMiddle ? 'CalendarViewDialog' : 'CalendarViewSideDialog';
      break;
    case NewMeeting:
    case MeetingDetail:
      compName = isMiddle ? 'MeetingViewDialog' : 'MeetingViewSideDialog';
      break;
    case MeetingRoomInfo:
      compName += 'RoomUsageCom';
      break;
    case NewCooperation:
      compName += 'CoworkNewCoworkDialog';
      break;
    case CooperationDetail:
      compName += `CoworkViewEdit${isMiddle ? '' : 'Side'}Dialog`;
      break;
    // 方案详情
    case PerformanceSchemeDetail:
      compName += 'PerformanceSchemeDetailDialogWapper';
      break;
    // 新建委托
    case PerformanceAgentEdit:
      compName += 'PerformanceAgentEditDialog';
      break;
    // 新建方案
    case PerformanceSchemeEdit:
      compName += 'PerformanceSchemeEditDialog';
      break;
    case PerformanceDetail:
      compName += 'PerformanceViewDialog';
      break;
    case PlanDetail:
      compName += 'PlanViewDialog';
      break;
    case DataDetail:
      compName = 'FormreportViewDialog';
      break;
    case NewProject:
    case ProjectDetail:
      compName = isMiddle ? 'ProjectViewDialog' : 'ProjectViewSideDialog';
      break;
    case ProjectBoard:
      compName = 'ProjectLinkPageCom';
      break;
    case ProjectStatusFlow:
      compName = 'EbProjectFormLayoutDialog';
      break;
    case NewTask:
    case TaskDetail:
      compName = isMiddle ? 'TaskViewDialog' : 'TaskViewSideDialog';
      break;
    case NewMarketActivity:
      compName = 'CrmCreateMarketActivityDialogProvider';
      break;
    case MarketActivityDetail:
      compName = isMiddle
        ? 'CrmMarketActivityViewMiddleDialog'
        : 'CrmMarketActivityViewDialogProvider';
      break;
    case NewCompetitor:
      compName = 'CrmCreateCompetitorDialogProvider';
      break;
    case CompetitorDetail:
      compName = isMiddle ? 'CrmCompetitorViewMiddleDialog' : 'CrmCompetitorViewDialogProvider';
      break;
    case NewBusinessFormData:
      compName = 'FormreportViewDialog';
      break;
    case SendEmail:
      compName = 'MailNewDialog';
      break;
    case EmailDetail:
      compName = 'MailViewDetailSideDialog';
      break;
    case WriteDaily:
      compName = 'currentPublishComp';
      break;
    case AddOdocRequest:
      compName = 'OdocAddRequestDialog';
      break;
    case ItemDetail:
      compName += 'MyWaitDetailLocalCenter';
      break;
    case WeComCustomerDetails:
      compName = isMiddle ? 'MarketWechatCusViewMiddleDialog' : 'MarketWechatCusViewSideDialog';
      break;
    case IncreaseTrafficRecordDetails:
      compName = isMiddle ? 'MarketWechatDrainViewMiddleDialog' : 'MarketWechatDrainViewSideDialog';
      break;
    case NewCopywriting:
      compName = isMiddle
        ? 'MarketArticleCreateViewMiddleDialog'
        : 'MarketArticleCreateViewSideDialog';
      break;
    case Copywriting:
      compName = isMiddle ? 'MarketArticleViewMiddleDialog' : 'MarketArticleViewSideDialog';
      break;
    case PreviewCopywriting:
      compName = isMiddle ? 'MarketArticlePreViewMiddleDialog' : 'MarketArticlePreViewSideDialog';
      break;
    case Combinate:
      compName += 'CombinedPagePreDialogComp';
      break;
    case ContactIdentification:
      compName = 'CrmCardScanDialog';
      break;
    case ImportCustomer:
    case ImportContactReminder:
    case ImportContact:
    case ImportContactRecord:
      compName = 'CrmImportDialog';
      break;
    // 客户 - 新建联系提醒
    case CrmNewContactRemind:
      compName = 'CrmCreateRemindDialogProvider';
      break;
    case BatchEditCustomer:
    case BatchEditOpportunities:
    case BatchEditClues:
      compName = 'CrmBatchEdit';
      break;
    case GetSignLink:
      compName = 'SignLinkEb';
      break;
    case InvalidSign:
      compName = 'NullifySign';
      break;
    case WithdrawSign:
      compName = 'WithdrawFile';
      break;
    case StartSign:
      compName = 'StartSign';
      break;
    case RejectSign:
      compName = 'RejectSign';
      break;
    case CounterSign:
      compName = 'SignLink';
      break;
    case SignDetail:
      compName = 'SignContractViewDialog';
      break;
    case SignatureDetail:
      compName = 'SignatureDialog';
      break;
    case WithdrawApply:
      compName = 'WithdrawApply';
      break;
    case OdocDetail:
      compName = isMiddle ? comps[0] : comps[1];
      break;
    case OdocLibDetail:
      compName = 'DocDetailProvider';
      break;
    case InvoiceDetail: // 目前只有居中弹框
      compName = 'InvoiceDetailExDialog';
      break;
    default:
      break;
  }

  return compName;
};

export const getCorsProps = (
  id: string,
  placement: string,
  urlParams: any,
  winSize?: string,
  isBlankClose?: boolean,
  callbacks?: (isEventEmitter?: boolean) => void,
  saveCallBacks?: (data: any) => void,
  onTaskAfterSave?: (actionId: string, data: any) => void,
) => {
  let corsProps: any = {};

  const screenHeight = document.body.clientHeight - 60;
  const dlgTop = getDialogTopFormLeft();

  switch (id) {
    case NewSchedule: {
      const scheduleBaseProps = { idFromParent: 'create' };
      corsProps = placement === 'middle'
        ? {
          width: '800px',
          height: `${screenHeight}px`,
          top: '30px',
          ...scheduleBaseProps,
        }
        : {
          width: winSize || '800px',
          height: `calc(100% - ${dlgTop})`,
          top: dlgTop,
          ...scheduleBaseProps,
        };
      break;
    }
    case UploadFile:
      corsProps = placement === 'middle'
        ? { width: '600px', height: '400px', top: '100px' }
        : { width: winSize || '800px', height: `calc(100% - ${dlgTop})`, top: dlgTop };
      break;

    case DataDetail:
      corsProps = placement === 'middle'
        ? {
          dialogParam: {
            width: '800px',
            height: `${screenHeight}px`,
            top: '30px',
            noMaskClose: isBlankClose,
          },
          idFromParent: urlParams?.id,
        }
        : {
          width: winSize || '800px',
          height: `calc(100% - ${dlgTop})`,
          top: dlgTop,
          dialogParam: {
            width: winSize || '800px',
            height: `calc(100% - ${dlgTop})`,
            top: dlgTop,
            noMaskClose: isBlankClose,
          },
          idFromParent: urlParams?.id,
        };
      break;

    case NewBusinessFormData:
      corsProps = placement === 'middle'
        ? {
          dialogParam: {
            width: '800px',
            height: `${screenHeight}px`,
            top: '30px',
          },
          formId: urlParams?.id || '-1',
        }
        : {
          width: winSize || '800px',
          height: `calc(100% - ${dlgTop})`,
          top: dlgTop,
          dialogParam: {
            width: winSize || '800px',
            height: `calc(100% - ${dlgTop})`,
            top: dlgTop,
          },
          formId: urlParams?.id || '-1',
        };
      break;

    case NewProject:
      corsProps = placement === 'middle'
        ? {
          width: '800px',
          height: `${screenHeight}px`,
          top: '30px',
          title: getLabel('90717', '新建项目'),
          actionCallback: callbacks,
        }
        : {
          width: winSize || '800px',
          height: `calc(100% - ${dlgTop})`,
          top: dlgTop,
          title: getLabel('90717', '新建项目'),
          actionCallback: callbacks,
        };
      break;

    case NewCompetitor:
    case NewMarketActivity:
    case NewContact:
    case NewPrice:
    case NewCustomer:
    case NewOpportunity:
    case NewProduct:
    case NewClue:
    case NewContract:
      corsProps = placement === 'middle'
        ? {
          width: '800px',
          height: `${screenHeight}px`,
          top: '30px',
          callbacks: saveCallBacks,
        }
        : {
          width: winSize || '800px',
          height: `calc(100% - ${dlgTop})`,
          top: dlgTop,
          callbacks: saveCallBacks,
        };
      break;
    case NewOrder:
      corsProps = placement === 'middle'
        ? {
          width: '800px',
          height: `${screenHeight}px`,
          top: '30px',
          callbacks: { success: saveCallBacks },
        }
        : {
          width: winSize || '800px',
          height: `calc(100% - ${dlgTop})`,
          top: dlgTop,
          callbacks: { success: saveCallBacks },
        };
      break;
    case DocumentDetail: {
      const dialogProps = placement === 'middle'
        ? {
          width: '800px',
          height: `${screenHeight}px`,
          top: '30px',
          paramsFromParent: { openAccFromPortal: urlParams?.openAccFromPortal },
        }
        : {
          width: winSize || '800px',
          height: `calc(100% - ${dlgTop})`,
          top: dlgTop,
          paramsFromParent: { openAccFromPortal: urlParams?.openAccFromPortal },
        };

      if (isPassportEbpage()) {
        corsProps = {
          id: urlParams?.id || '',
          // eslint-disable-next-line max-len
          tenantKey: window?.TEAMS?.currentTenant?.tenantKey || window?.e_customPageData?.tenantKeyForEb,
          source: 'notLogin',
          dialogProps: {
            ...dialogProps,
            placement,
          },
        };
      } else {
        corsProps = dialogProps;
      }
      break;
    }

    case SendEmail:
      corsProps = placement === 'middle'
        ? {
          width: '800px',
          height: `${screenHeight}px`,
          top: '30px',
          noMaskClose: isBlankClose,
          onClose: callbacks,
        }
        : {
          width: winSize || '800px',
          height: `calc(100% - ${dlgTop})`,
          top: dlgTop,
          noMaskClose: isBlankClose,
          onClose: callbacks,
        };
      break;
    case WriteDaily:
      corsProps = placement === 'middle'
        ? {
          className: classnames(
            `${pageViewClsPrefix}-route-dlg ${pageViewClsPrefix}-s-dlg-w-d`,
          ),
          maskClosable: isBlankClose,
          icon: 'Icon-daily-o',
          iconBgcolor: 'red',
          width: '800px',
          height: `${screenHeight}px`,
          top: '30px',
        }
        : {
          className: classnames(
            `${pageViewClsPrefix}-route-dlg ${pageViewClsPrefix}-s-dlg-w-d`,
          ),
          maskClosable: isBlankClose,
          icon: 'Icon-daily-o',
          iconBgcolor: 'red',
          width: winSize || '800px',
          height: `calc(100% - ${dlgTop})`,
          top: dlgTop,
        };
      break;
    case Scene:
      corsProps = placement === 'middle'
        ? {
          width: '80%',
          height: `${screenHeight}px`,
          top: '30px',
        }
        : {
          width: String(winSize || '800px'),
          height: `calc(100% - ${dlgTop})`,
          top: dlgTop,
        };
      break;
    case CooperationDetail:
      corsProps = placement === 'middle'
        ? {
          width: '800px',
          height: `${screenHeight}px`,
          top: '30px',
          paramsFromParent: { floornum: '' },
          dialogProps: {
            width: '800px',
            height: `${screenHeight}px`,
            top: '30px',
            paramsFromParent: { floornum: '' },
          },
          newDialogProps: {
            placement: 'middle',
            width: '800px',
            height: `${screenHeight}px`,
            top: '30px',
          },
        }
        : {
          width: winSize || '800px',
          height: `calc(100% - ${dlgTop})`,
          top: dlgTop,
          paramsFromParent: { floornum: '' },
        };
      break;
    case ItemDetail: {
      corsProps = placement === 'middle'
        ? {
          width: '800px',
          height: `${screenHeight}px`,
          top: '30px',
          onClose: callbacks,
          entity: urlParams?.id,
        }
        : {
          width: winSize || '800px',
          height: `calc(100% - ${dlgTop})`,
          top: dlgTop,
          onClose: callbacks,
          entity: urlParams?.id,
        };
      break;
    }
    case WeComCustomerDetails:
    case IncreaseTrafficRecordDetails:
    case Copywriting:
    case PreviewCopywriting:
      corsProps = placement === 'middle'
        ? {
          width: '800px',
          height: `${screenHeight}px`,
          top: '30px',
        }
        : {
          width: winSize || '800px',
          height: `calc(100% - ${dlgTop})`,
          top: dlgTop,
        };
      break;
    case OdocDetail:
    case OdocLibDetail:
      corsProps = placement === 'middle'
        ? {
          width: '1230px',
          height: `${screenHeight}px`,
          top: '30px',
        }
        : {
          width: winSize || '800px',
          height: `calc(100% - ${dlgTop})`,
          top: dlgTop,
        };
      break;
    default:
      corsProps = placement === 'middle'
        ? {
          width: '800px',
          height: `${screenHeight}px`,
          top: '30px',
          onClose: callbacks,
        }
        : {
          width: winSize || '800px',
          height: `calc(100% - ${dlgTop})`,
          top: dlgTop,
          onClose: callbacks,
        };
      break;
  }

  switch (id) {
    case NewProject:
      corsProps = { ...corsProps, idFromParent: 'create', pageType: 'createFromPortal' };
      break;
    case ProjectBoard:
      corsProps = {
        ...corsProps,
        type: 'mine',
        targetId: urlParams?.id,
        isStopPropagation: true,
      };
      break;
    case NewTask:
      corsProps = { ...corsProps, idFromParent: 'create', actionCallback: onTaskAfterSave };
      break;
    case NewMeeting:
      corsProps = { ...corsProps, idFromParent: '', operateType: 'ADD' };
      break;
    case NewDocument:
      corsProps = placement === 'middle'
        ? { height: `${screenHeight}px`, top: '30px' }
        : { height: `calc(100% - ${dlgTop})`, top: dlgTop };
      corsProps = { ...corsProps, params: { folderId: '300', contentType: 'html' }, id: '' };
      break;
    case AddOdocRequest:
      corsProps = {
        isDialog: true,
        cusDialogProps: {
          placement,
        },
      };

      corsProps = placement === 'middle'
        ? corsProps
        : {
          ...corsProps,
          cusDialogProps: {
            placement,
            height: `calc(100% - ${dlgTop})`,
            top: dlgTop,
            width: winSize || '800px',
          },
        };
      break;
    case GetSignLink:
      corsProps = { dialogProps: corsProps, contractId: urlParams?.id };
      break;
    case InvalidSign:
    case WithdrawSign:
      corsProps = { dialogProps: corsProps, fileid: urlParams?.id || '-1' };
      break;
    case StartSign:
    case RejectSign:
    case CounterSign:
    case SignDetail:
    case SignatureDetail:
    case WithdrawApply:
      corsProps = { dialogProps: corsProps };
      break;
    case OdocDetail:
      corsProps = placement === 'middle'
        ? { ...corsProps, requestId: urlParams?.id }
        : { ...corsProps, idFromParent: urlParams?.id };
      break;
    case OdocLibDetail:
      corsProps = { ...corsProps, id: urlParams?.id };
      break;
    default:
      break;
  }

  // 绩效报表弹窗组件高度写死为固定值，右侧划出时外部需传入高度铺满
  if (placement === 'right' && [PerformanceDetail].includes(id)) {
    corsProps.height = '100%';
  }

  corsProps = { ...corsProps, comParams: { ...urlParams } };

  return corsProps;
};

export const fomatParentPath = (props: RouteComponentProps) => {
  if (props.history.location.pathname && props.history.location.pathname) {
    return props.history.location.pathname.replace(/\/$/, () => '');
  }
  return '';
};

class SystemDialog extends React.PureComponent<
  BaseProps & RouteComponentProps<{ type: string; id: string }>,
  {
    parentPath: string;
    linkQueue: AnyObj;
  }
> {
  state: {
    parentPath: string;
    linkQueue: AnyObj;
  } = {
    parentPath: '',
    linkQueue: {},
  };

  needNewModal: boolean = false;

  needSaveRefresh: boolean = false;

  modalName: string = '';

  componentDidMount() {
    const parentPath = fomatParentPath(this.props);
    this.setState({ parentPath });

    eventEmitter?.on('@weapp/ebdcoms', 'jumplink.link', this.handleJump);
    eventEmitter?.on('@weapp/ebdpage', 'dialog.close', this.onDialogClose);
  }

  // 组件卸载时清除事件监听
  componentWillUnmount() {
    window.removeEventListener('popstate', () => {}, false);
    eventEmitter?.off('@weapp/ebdcoms', 'jumplink.link', this.handleJump);
    eventEmitter?.off('@weapp/ebdpage', 'dialog.close', this.onDialogClose);
  }

  getBaseStr = (linkPath: string) => {
    const [, firstDlg, secondDlg] = linkPath.split(suffix);
    let baseStr = firstDlg;

    if (secondDlg) {
      [baseStr] = secondDlg.split('/');
    }
    return baseStr;
  };

  handleJump = (link: string, otherProps?: OtherProps) => {
    const { PageType: _PageType } = ebdcoms.get();
    const { linkQueue } = this.state;

    runInAction(() => {
      if ([_PageType.SystemPage, _PageType.Combinate].includes(otherProps?.pageType)) {
        const hasLink = Object.keys(this.state.linkQueue).includes(link);
        if (!hasLink) {
          this.setState({
            linkQueue: { ...linkQueue, [link]: {} },
          });
        } else {
          this.state.linkQueue?.[link]?.setVisible?.(true);
        }
      }
    });
  };

  onDialogClose = (otherProps: OtherProps) => {
    const { PageType: _PageType } = ebdcoms.get();

    // 支持单独关闭某一类弹窗、不传pageType则关闭所有通过event打开的弹窗
    if (!otherProps?.pageType && !otherProps?.closeAll) {
      this.onClose(true);
    } else if (
      [_PageType.SystemPage, _PageType.Combinate].includes(otherProps?.pageType)
      || otherProps?.closeAll
    ) {
      this.onClose(true, true);
    }
  };

  onClose = (isEventEmitter?: boolean, isAll?: boolean) => {
    Object.keys(this.state.linkQueue).forEach((l: string) => {
      this.state.linkQueue?.[l]?.onClose?.(isEventEmitter, isAll);
    });
  };

  render() {
    const { linkQueue } = this.state;

    return Object.keys(linkQueue).map((link: string) => {
      const node = (
        <SingCom
          weId={`${this.props.weId || ''}_pu9aon`}
          // eslint-disable-next-line react/jsx-no-bind, no-return-assign
          ref={(ref) => (linkQueue[link] = ref)}
          link={link}
          parentPath={this.state.parentPath}
          SingleComProps={this.props}
        />
      );

      return <div key={link}>{node}</div>;
    });
  }
}
export default withRouter(SystemDialog);
